export const INTRODUCTION_CONSTANTS = {
  CONTENT:
    "OneMind Services Cloud Application and Management services give you complete peace of mind by following a cradle-to-cloud approach.Cloud Deployment and Migration:-Deploy any application on any cloud-Migrate any workload to any cloudMobile man shown with cloud computing diagram in hand. cloud technology data storage network and internet service concept",
  SERVICE: "SERVICE",
  HEADING: "Cloud Application and Management",
};

export const CLOUD_MANAGEMENT = {
  LIST: [
    "Service management",
    "Integrated monitoring of cloud environment",
    "Automated alerts and recovery mechanism",
    "Governance and Compliance Audit",
    "Governance and Compliance Audit",
    "99.9% service availability",
  ],
  TITLE: "Cloud Management",
};
